// Next Diamonds - PDP Sticky CTA controller v2
// Scroll-based trigger. Sticky shows once user has scrolled past a threshold AND
// the main Add to Cart button is not currently visible in the viewport.
// Clicking the sticky button triggers the main form submit.

(function () {
  'use strict';

  function init() {
    var sticky = document.getElementById('nd-sticky-cta');
    if (!sticky) return;

    var mainSubmit = document.querySelector('.product-form__submit, button[name="add"]');
    if (!mainSubmit) return;

    // Show after the user has scrolled past 30% of the viewport height.
    function triggerScrollPx() {
      return Math.max(180, window.innerHeight * 0.30);
    }

    function check() {
      var scrolled = window.scrollY || window.pageYOffset || 0;
      if (scrolled < triggerScrollPx()) {
        setVisible(false);
        return;
      }
      var rect = mainSubmit.getBoundingClientRect();
      var inView = rect.top < window.innerHeight - 40 && rect.bottom > 0;
      setVisible(!inView);
    }

    function setVisible(on) {
      if (on) {
        sticky.classList.add('nd-sticky-cta--visible');
        sticky.setAttribute('aria-hidden', 'false');
      } else {
        sticky.classList.remove('nd-sticky-cta--visible');
        sticky.setAttribute('aria-hidden', 'true');
      }
    }

    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check, { passive: true });
    check();

    var stickyBtn = sticky.querySelector('[data-nd-sticky-add]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        mainSubmit.click();
      });
    }

    // Mirror price changes from the main price block. We prefer the
    // ND-discounted price (nd-price-discounted, written by pdp-price-discount.js
    // and pdp-carat-selector.js). Fall back to .price__current (compare-at) if
    // no discount is active.
    var stickyPrice = sticky.querySelector('[data-nd-sticky-price]');
    if (stickyPrice) {
      function readPrice() {
        var dEl = document.querySelector('.nd-price-discounted');
        if (dEl && dEl.textContent.trim()) {
          return dEl.textContent.replace(/\s+/g, ' ').trim();
        }
        var cEl = document.querySelector('.price__current');
        if (cEl && cEl.textContent.trim()) {
          return cEl.textContent.replace(/\s+/g, ' ').trim();
        }
        return '';
      }
      function sync() {
        var t = readPrice();
        if (t) stickyPrice.textContent = t;
      }
      sync();
      // Watch BOTH the discounted and current price elements. Whichever ND
      // updates (carat change rewrites .price__current; price-discount.js then
      // updates .nd-price-discounted), the sticky stays in sync.
      var watched = [];
      [
        '.nd-price-discounted',
        '.price__current',
        '.price__default .price__current',
        '.price-item--regular'
      ].forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          if (watched.indexOf(el) !== -1) return;
          watched.push(el);
          var mo = new MutationObserver(sync);
          mo.observe(el, { childList: true, subtree: true, characterData: true });
        });
      });
      // Late-arriving elements (Symmetry mounts price asynchronously sometimes).
      setTimeout(sync, 500);
      setTimeout(sync, 1500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
